import * as React from 'react';
import {Banner} from '@shopify/polaris';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import i18nArgs from '../../locales';

import styles from './ExpertUnavailable.scss';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

function ExpertUnavailable({i18n}: CombinedProps) {
  return (
    <div className={styles.BannerContainer}>
      <Banner>{i18n.translate('Profile.ExpertUnavailable.bannerText')}</Banner>
    </div>
  );
}

export default withI18n(i18nArgs)(ExpertUnavailable);
